<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentrow: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				modal_model: false,
				modal_title: '成本明细',
				modal_width: 1200,
				modal_height: 800,
				list_footerField: [{
						field: 'tp_payment',
						toFixed: 2
					},{
						field: 'real_payment',
						toFixed: 2
					},
					{
						field: 'receivable_fee',
						toFixed: 2
					},
					{
						field: 'itemCost',
						toFixed: 2
					}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			if (this.currentrow) {
				this.modal_title = '成本明细【' + this.currentrow.title + '】'
			}
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width: 60,
					}, {
						field: 'skuOlnPic',
						title: '图片',
						width: 60,
						slots: {
							default: ({
								row
							}) => {
								if (row.skuOlnPic) {
									return [ <el-image style = "width: 30px; height: 30px" src = {row.skuOlnPic} preview-src-list = {[row.skuOlnPic]} > </el-image>]
								} else {
									return null
								}

							}
						}
					},
					{
						field: 'tp_item_id',
						title: 'spuID'
					},
					{
						field: 'tp_sku_id',
						title: 'skuID'
					},
					{
						field: 'onlinelprice',
						title: '线上价格'
					},
					{
						field: 'onlinelsubprice',
						title: '券后价格'
					},
					{
						field: 'quantityText',
						title: '状态'
					},
					{
						field: 'skuName',
						title: 'sku名称'
					},
					{
						field: 'goodsCode',
						title: '万里牛编码'
					},
					{
						field: 'tp_payment',
						title: '万里牛销售额',
						sortable: true,
					},
					{
						field: 'receivable_fee',
						title: '万里牛售后额',
						sortable: true,
					},
					{
						field: 'real_payment',
						title: '万里牛净销售',
						sortable: true,
					},
					{
						field: 'itemCost',
						title: '万里牛成本',
						sortable: true,
					},
					{
						field: 'salercpt_no',
						title: '销售单号'
					},
					{
						field: 'exchange_no',
						title: '售后单号'
					},
					// {
					// 	field: '',
					// 	title: '操作',
					// 	width: 65,
					// 	fixed: "right",
					// 	align: 'center',
					// 	slots: {
					// 		default:({row})=>{
					// 			return	[
					// 					<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.deleteitemtogroup(row)}}>跳转</el-button>,
					// 				]
					// 		}
					// 	}
					// },
				]
				
				gridOptions.columns.forEach((item)=>{
					item.showHeaderOverflow = 'title'
				})
			
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = this.$Lodash.orderBy(this.currentrow.costdetail.detail, item => parseInt(item
						.tp_payment), ['desc'])



					let itemid = data.map((item) => {
						return item.tp_item_id
					})
					let skuid = data.map((item) => {
						return item.tp_sku_id
					})
					this.$api.BIshopgoods.getonlineinfo({
						skuid: skuid,
						itemid: itemid,
					}).then((res) => {
						let info = res.data
						data.forEach((item, index) => {
							let obj = info.find((_item) => {
								if (res.type == 'sku') {
									return _item.skuId == item.tp_sku_id
								} else {
									return _item.skuId == item.tp_item_id
								}

							})
							if (obj) {
								data[index] = {
									...item,
									...obj
								}
							}
							
							if(this.currentrow.exchangecostdetail){
								let exchangeobj = this.currentrow.exchangecostdetail.detail.find((
									_item) => {
									return item.tp_item_id == _item.tp_item_id && item
										.tp_sku_id == _item.tp_sku_id
								})
								if (exchangeobj) {
									data[index]['exchange_no'] = exchangeobj['exchange_no']
									data[index]['receivable_fee'] = exchangeobj['receivable_fee']
									data[index]['exchange_itemCost'] = exchangeobj['itemCost']
									data[index]['itemCost'] = (data[index]['itemCost'] ? parseFloat(data[index]['itemCost']) : 0) - (data[index]['exchange_itemCost'] ? parseFloat(data[index]['exchange_itemCost']) : 0)					
									data[index]['itemCost'] = data[index]['itemCost'].toFixed(2)
								}
								data[index]['real_payment'] = (data[index]['tp_payment'] ? parseFloat(data[index]['tp_payment']) : 0) - (data[index]['receivable_fee'] ? parseFloat(data[index]['receivable_fee']) : 0)
								data[index]['real_payment'] = data[index]['real_payment'].toFixed(2)
							}
	

						})
						resolve({
							list: data
						})
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>